"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PvdExpandCollapse =
/*#__PURE__*/
function (_HTMLElement) {
  _inherits(PvdExpandCollapse, _HTMLElement);

  _createClass(PvdExpandCollapse, [{
    key: "template",
    value: function template() {
      var templateEl = document.createElement('template');
      templateEl.innerHTML = "\n        <!-- Start Style --><style>button.pvd-btn,input[type=button].pvd-btn,a.pvd-btn{font-family:\"Fidelity Sans\",Arial,sans-serif;padding:0.5em 1em;margin:0;cursor:pointer;vertical-align:middle;border:1px solid #ccc;border-radius:.1875em;font-size:1em;display:inline-flex;align-items:center;align-self:flex-start;justify-content:center;color:#000;border-color:#ccc;background-color:#f2f2f2}button.pvd-btn::-moz-focus-inner,input[type=button].pvd-btn::-moz-focus-inner,a.pvd-btn::-moz-focus-inner{border:0;padding:0}button.pvd-btn:not(:disabled):active,button.pvd-btn:not(:disabled):focus,input[type=button].pvd-btn:not(:disabled):active,input[type=button].pvd-btn:not(:disabled):focus,a.pvd-btn:not(:disabled):active,a.pvd-btn:not(:disabled):focus{border-color:#fff;outline:.0625em dotted transparent;box-shadow:0 0 0 0.125em #000}button.pvd-btn pvd-icon,input[type=button].pvd-btn pvd-icon,a.pvd-btn pvd-icon{margin-right:0.5em}button.pvd-btn:not(:disabled):hover,input[type=button].pvd-btn:not(:disabled):hover,a.pvd-btn:not(:disabled):hover{background-image:none !important;text-decoration:none}button.pvd-btn:disabled,input[type=button].pvd-btn:disabled,a.pvd-btn:disabled{opacity:0.5;cursor:default}button.pvd-btn.btn-anchor{font-family:\"Fidelity Sans\",Arial,sans-serif;padding:0;cursor:pointer;border:none;border-radius:0;font-size:1em;display:inline-flex;background-color:transparent;line-height:inherit;vertical-align:top;color:#0E67A9;text-decoration:none}button.pvd-btn.btn-anchor:not(:disabled):hover{text-decoration:underline}button.pvd-btn.btn-anchor:not(:disabled):focus,button.pvd-btn.btn-anchor:not(:disabled):active{outline:dotted 1px #000;border:none;box-shadow:none}button.pvd-btn.btn-anchor.pvd-truncate-action{font-size:1em;vertical-align:baseline}:host{display:block;margin-bottom:1em;width:100%}:host(.xlarge) button.expand-collapse-trigger{font-size:1.125em;font-weight:300}@media screen and (min-width: 32em){:host(.xlarge) button.expand-collapse-trigger{font-size:1.25em}}@media screen and (min-width: 60em){:host(.xlarge) button.expand-collapse-trigger{font-size:1.4375em}}:host(.xlarge) div.expand-collapse-content{font-size:1.125em}@media screen and (min-width: 32em){:host(.xlarge) div.expand-collapse-content{font-size:1.25em}}@media screen and (min-width: 60em){:host(.xlarge) div.expand-collapse-content{font-size:1.4375em}}:host(.large) button.expand-collapse-trigger{font-size:1em}@media screen and (min-width: 32em){:host(.large) button.expand-collapse-trigger{font-size:1.125em}}@media screen and (min-width: 60em){:host(.large) button.expand-collapse-trigger{font-size:1.3125em}}:host(.large) div.expand-collapse-content{font-size:1em}@media screen and (min-width: 32em){:host(.large) div.expand-collapse-content{font-size:1.125em}}@media screen and (min-width: 60em){:host(.large) div.expand-collapse-content{font-size:1.3125em}}:host(.small) button.expand-collapse-trigger{font-size:.75em}@media screen and (min-width: 32em){:host(.small) button.expand-collapse-trigger{font-size:.875em}}@media screen and (min-width: 60em){:host(.small) button.expand-collapse-trigger{font-size:1em}}:host(.small) div.expand-collapse-content{font-size:.75em}@media screen and (min-width: 32em){:host(.small) div.expand-collapse-content{font-size:.875em}}@media screen and (min-width: 60em){:host(.small) div.expand-collapse-content{font-size:1em}}:host(.xsmall) button.expand-collapse-trigger{font-size:.75em}@media screen and (min-width: 32em){:host(.xsmall) button.expand-collapse-trigger{font-size:.75em}}@media screen and (min-width: 60em){:host(.xsmall) button.expand-collapse-trigger{font-size:.75em}}:host(.xsmall) div.expand-collapse-content{font-size:.75em}@media screen and (min-width: 32em){:host(.xsmall) div.expand-collapse-content{font-size:.75em}}@media screen and (min-width: 60em){:host(.xsmall) div.expand-collapse-content{font-size:.75em}}pvd-expand-collapse{display:block;margin-bottom:1em;width:100%}pvd-expand-collapse.xlarge div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:1.125em;font-weight:300}@media screen and (min-width: 32em){pvd-expand-collapse.xlarge div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:1.25em}}@media screen and (min-width: 60em){pvd-expand-collapse.xlarge div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:1.4375em}}pvd-expand-collapse.xlarge div.expand-collapse-content{font-size:1.125em}@media screen and (min-width: 32em){pvd-expand-collapse.xlarge div.expand-collapse-content{font-size:1.25em}}@media screen and (min-width: 60em){pvd-expand-collapse.xlarge div.expand-collapse-content{font-size:1.4375em}}pvd-expand-collapse.large div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:1em}@media screen and (min-width: 32em){pvd-expand-collapse.large div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:1.125em}}@media screen and (min-width: 60em){pvd-expand-collapse.large div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:1.3125em}}pvd-expand-collapse.large div.expand-collapse-content{font-size:1em}@media screen and (min-width: 32em){pvd-expand-collapse.large div.expand-collapse-content{font-size:1.125em}}@media screen and (min-width: 60em){pvd-expand-collapse.large div.expand-collapse-content{font-size:1.3125em}}pvd-expand-collapse.small div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:.75em}@media screen and (min-width: 32em){pvd-expand-collapse.small div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:.875em}}@media screen and (min-width: 60em){pvd-expand-collapse.small div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:1em}}pvd-expand-collapse.small div.expand-collapse-content{font-size:.75em}@media screen and (min-width: 32em){pvd-expand-collapse.small div.expand-collapse-content{font-size:.875em}}@media screen and (min-width: 60em){pvd-expand-collapse.small div.expand-collapse-content{font-size:1em}}pvd-expand-collapse.xsmall div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:.75em}@media screen and (min-width: 32em){pvd-expand-collapse.xsmall div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:.75em}}@media screen and (min-width: 60em){pvd-expand-collapse.xsmall div button.pvd-btn.btn-anchor.expand-collapse-trigger{font-size:.75em}}pvd-expand-collapse.xsmall div.expand-collapse-content{font-size:.75em}@media screen and (min-width: 32em){pvd-expand-collapse.xsmall div.expand-collapse-content{font-size:.75em}}@media screen and (min-width: 60em){pvd-expand-collapse.xsmall div.expand-collapse-content{font-size:.75em}}button.expand-collapse-trigger{align-items:flex-start;text-align:left}button.expand-collapse-trigger pvd-icon{width:1em;height:1em;margin-right:0.5em;display:block;flex-grow:0;flex-shrink:0;align-self:flex-start;transform:translateY(0.15em)}div.expand-collapse-content{font-size:.875em;padding-left:1.5em;display:none;height:0;overflow:hidden;transition:height 250ms ease-in-out}@media screen and (min-width: 32em){div.expand-collapse-content{font-size:1em}}@media screen and (min-width: 60em){div.expand-collapse-content{font-size:1.125em}}@media screen and (min-width: 32em){button.expand-collapse-trigger{font-size:1em}}@media screen and (min-width: 60em){button.expand-collapse-trigger{font-size:1.125em}}button.expand-collapse-trigger:hover{text-decoration:underline}div.expand-collapse-content{padding-left:1.5em;font-size:0.875em;display:none;height:0;overflow:hidden;transition:height 250ms ease-in-out}div.expand-collapse-content.is-visible{display:block;height:auto}.inserted-content{font-size:1rem}\n</style><!-- End Style -->\n<div>\n<button type=\"button\" class=\"pvd-btn btn-anchor expand-collapse-trigger\" aria-expanded=\"false\">\n<pvd-icon icon=\"show-more\" aria-hidden=\"true\" class=\"trigger-icon\"></pvd-icon> <span class=\"expand-collapse-title\"></span>\n<slot name=\"expand-collapse-title\"></slot>\n</button>\n<slot name=\"expand-collapse-additional-title\"></slot>\n<div>\n<div class=\"expand-collapse-content\" aria-hidden=\"true\">\n<div class=\"inserted-content\">\n    <slot></slot>\n</div>\n</div>\n    ";
      return templateEl.content;
    }
  }, {
    key: "title",
    get: function get() {
      return this.getAttribute("title");
    },
    set: function set(val) {
      this.setAttribute("title", val);
    }
  }, {
    key: "expanded",
    get: function get() {
      return this.getAttribute("expanded");
    },
    set: function set(val) {
      this.setAttribute("expanded", val);
    }
  }, {
    key: "animate",
    get: function get() {
      return this.getAttribute("expanded");
    },
    set: function set(val) {
      this.setAttribute("animate", val);
    }
  }, {
    key: "expandTitle",
    get: function get() {
      return this.getAttribute("expand-title");
    },
    set: function set(val) {
      this.setAttribute("expand-title", val);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['title', 'expanded', 'animate', 'expand-title'];
    }
  }]);

  function PvdExpandCollapse() {
    var _this;

    _classCallCheck(this, PvdExpandCollapse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PvdExpandCollapse).call(this));

    _this.attachShadow({
      mode: 'open'
    }).appendChild(_this.template().cloneNode(true));

    _this._expanded = "false";
    _this._title;
    _this._animate = "false";
    _this._expandTitle;
    _this._boundExpandCollapse = _this.toggleExpandCollapse.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PvdExpandCollapse, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var trigger = this.shadowRoot.querySelector(".expand-collapse-trigger"); // connectedCallback is called whenever the element is moved - in order to avoid double binding the event
      // we need to remove the handler and then add it.

      trigger.removeEventListener("click", this._boundExpandCollapse);
      trigger.addEventListener("click", this._boundExpandCollapse);
    }
  }, {
    key: "toggleExpandCollapse",
    value: function toggleExpandCollapse() {
      if (this._expanded == "true") {
        this.setAttribute("expanded", "false");
      } else {
        this.setAttribute("expanded", "true");
      }

      var customEvent = new CustomEvent("pvd-expand-collapse-change", {
        bubbles: true,
        cancelable: false,
        composed: true,
        detail: {
          expanded: this._expanded
        }
      });
      this.dispatchEvent(customEvent);
    }
  }, {
    key: "_getHeight",
    value: function _getHeight() {
      var elem = this.shadowRoot.querySelector(".expand-collapse-content");
      elem.style.display = "block";
      var height = elem.scrollHeight === 0 ? "auto" : elem.scrollHeight + "px";
      elem.style.display = "";
      return height;
    }
    /**
     * Set overflow to hidden during transition to prevent scrollbar from
     * appearing.
     */

  }, {
    key: "_setOverflow",
    value: function _setOverflow() {
      var elem = this.shadowRoot.querySelector(".expand-collapse-content");
      elem.style.overflow = "hidden";

      var listener = function listener(e) {
        if (e.type === "transitionend" || e.type === "transitioncancel") {
          elem.style.overflow = "auto";
          elem.removeEventListener("transitionend", listener);
          elem.removeEventListener("transitioncancel", listener);
        }
      };
      /**
       * Add listeners for both transitionend and transitioncancel because
       * IE 11 fires transitioncancel while other browsers file transitionend
       */


      elem.addEventListener("transitionend", listener);
      elem.addEventListener("transitioncancel", listener);
    }
  }, {
    key: "showContent",
    value: function showContent() {
      var elem = this.shadowRoot.querySelector(".expand-collapse-content");
      var content = this.shadowRoot.querySelector(".expand-collapse-content");
      var trigger = this.shadowRoot.querySelector(".expand-collapse-trigger");
      var icon = this.shadowRoot.querySelector(".trigger-icon");

      if (this._animate === "true") {
        this._setOverflow();

        var height = this._getHeight(); // Get the natural height


        elem.classList.add("is-visible");
        elem.style.height = height;
        setTimeout(function () {
          elem.style.height = "auto";
        }, 250);
      } else {
        elem.style.display = "block";
        elem.style.height = "auto";
      }

      content.setAttribute("aria-hidden", "false");
      trigger.setAttribute("aria-expanded", "true");
      icon.setAttribute("icon", "show-less");

      if (this._expandTitle) {
        this.shadowRoot.querySelector(".expand-collapse-title").innerText = this._expandTitle;
      }
    }
  }, {
    key: "hideContent",
    value: function hideContent() {
      var elem = this.shadowRoot.querySelector(".expand-collapse-content");
      var content = this.shadowRoot.querySelector(".expand-collapse-content");
      var trigger = this.shadowRoot.querySelector(".expand-collapse-trigger");
      var icon = this.shadowRoot.querySelector(".trigger-icon");

      if (this._animate === "true") {
        this._setOverflow();

        if (!elem.classList.contains("is-visible")) {
          elem.classList.add("is-visible");
        }

        elem.style.height = elem.scrollHeight + 'px';
        window.setTimeout(function () {
          elem.style.height = '0';
        }, 1);
        window.setTimeout(function () {
          elem.classList.remove('is-visible');
        }, 250);
      } else {
        elem.style.display = "none";
      }

      content.setAttribute("aria-hidden", "true");
      trigger.setAttribute("aria-expanded", "false");
      icon.setAttribute("icon", "show-more");

      if (this.shadowRoot.querySelector(".expand-collapse-title").innerText != this._title) {
        this.shadowRoot.querySelector(".expand-collapse-title").innerText = this._title;
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case 'title':
          this._title = newValue;
          this.shadowRoot.querySelector(".expand-collapse-title").innerText = this._title;
          break;

        case 'expanded':
          this._expanded = newValue;

          if (this._expanded == 'true') {
            this.showContent();
          } else {
            this.hideContent();
          }

          break;

        case 'expand-title':
          if (newValue && newValue.length) {
            this._expandTitle = newValue;
          } else {
            this.removeAttribute("expand-title");
            this._expandTitle = '';
            this.shadowRoot.querySelector(".expand-collapse-title").innerText = this._title;
          }

          if (this._expanded == "true" && this.shadowRoot.querySelector(".expand-collapse-title").innerText != this._expandTitle) {
            this.shadowRoot.querySelector(".expand-collapse-title").innerText = this._expandTitle;
          }

          break;

        case 'animate':
          this._animate = newValue;
          break;
      }
    }
  }]);

  return PvdExpandCollapse;
}(_wrapNativeSuper(HTMLElement));

if (!!customElements.get('pvd-expand-collapse') == false) {
  customElements.define("pvd-expand-collapse", PvdExpandCollapse);
}